// 职业探索
import React from 'react'

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';

import CareerCard from '../component/CareerCard';
import WaterfallCard from '../component/WaterfallCard';
import CareerVideo from '../component/CareerVideo';

class CareerExplore extends React.Component 
{
    constructor( props )
    {
        super(props);

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {

            sourcePath: Config.getSourcePath(),

            userInfo: userInfo || {},

            welcomeWord:"我是您的职业规划师，现在开始进行您的职业规划",
            isHistory: false,
            // historyData:[ 
            //     {title:"探索职业道路", description:"您好，我是您的职业规划师，很高兴跟你一起探讨职业道路的话题，让我们共同寻找适合你的职业方向。今天有什么可以为您提供帮助？", date:"4月24日"},
            //     {title:"探索职业道路1", description:"您好，我是您的职业规划师，很高兴跟你一起探讨职业道路的话题。", date:"4月25日"}
            // ],
            recommendData:[
                { img:"img1.png" , title:"认识自我", time:"20~50分钟", description:"认识自我，是一场与内心对话的觉醒之旅。更能够看清自己的优势与局限，承认自己，接纳自己，并拥抱自己，不断学习努力，向前！", status:"100人已完成探讨"},
                { img:"img2.png" , title:"探索职业路径", time:"20~50分钟", description:"你知道自己适合什么职业了吗？小职这里根据大数据为你推荐了一些与你的专业、兴趣、价值观相匹配的职业，快去探索下职位的具体内容吧！同时你也可以通过搜索职业信息库，收藏喜欢的职业来确定自己的职业目标哦！", status:"100人已完成探讨"},
                { img:"img5.png" , title:"职业提升&转型", time:"20~50分钟", description:"了解如何使用关键词和行业术语来有效地推广新领域的先前经验。", status:"100人已完成探讨"},
                { img:"img4.png" , title:"职业技能培养", time:"20~50分钟", description:"通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。", status:"100人已完成探讨"},
                { img:"img5.png" , title:"如何将专业与职业结合", time:"20~50分钟", description:"将您当前的学术学习与未来的职业机会联系起来。了解学校科目如何与各种职业相关，确定必要的职业技能，并学习如何有效地组织您的学习。", status:"100人已完成探讨"},
                { img:"img6.png" , title:"提升面试技巧", time:"20~50分钟", description:"面试不是考试，而是​​「价值交易」的预演​​——用你的解决方案匹配对方的业务需求，用职业人格魅力对冲薪资谈判筹码。", status:"100人已完成探讨"}
            ],
            videoData:[
                { img:"img1.png" , title:"认识自我", time:"28:01", praise:"28"},
                { img:"img2.png" , title:"探索职业路径", time:"28:01", praise:"28"}
            ],
            videoTotal:3
        }
    }

    componentDidMount()
    {

    }

    notify = ( item ) => {

        this.props.history.push({ pathname: "/home/career-explore-ai", state: { item } });

    }

    recommendNotify = ( item ) => {
        this.props.history.push({ pathname: "/home/career-explore-ai", state: { item } });
    }

    videoNotify = ( item ) => {

    }

    render()
    {
        const { sourcePath, userInfo, welcomeWord, isHistory, historyData, recommendData, videoData, videoTotal} = this.state;
        
        return (
            <div className="sf-page" component-data="career-planning">
                <div className='sf-career-top' style={{minHeight:905}}>
                    <div className='sf-career-top-body sf-padding-50'>
                        <div className='sf-career-explore'>
                            <div className='sf-career-title-welcome'>
                                <div className='sf-vertical-line'></div>
                                <div className='sf-welcome-right'>
                                    <span>Hello，{ userInfo.realname }！ </span>
                                    <div className='sf-welcome'>
                                    {
                                        isHistory ? <>
                                            <div className='sf-welcome-history'>{welcomeWord}</div>
                                            <div className='sf-welcome-history-more'> 查看更多&gt;&gt;</div>
                                        </>
                                        :
                                        <>
                                            <span className='sf-welcome-message'> {welcomeWord}</span>
                                        </>
                                    }
                                    </div>
                                </div>
                            </div>

                            {
                                historyData && historyData.length > 0 ? 
                                    <div className='sf-career-history'>
                                        <CareerCard data={historyData} notify={this.notify} ></CareerCard>
                                    </div>
                                    :<></>
                            }

                            <div className='sf-career-explore-recommend'>
                                <div className='sf-career-explore-title'>
                                    <div className='sf-career-explore-title-body'>
                                        <img src={require('./../../img/' + sourcePath + '/career/recommend.png')} alt=""></img>
                                        {
                                            historyData && historyData.length > 0 
                                            ? <div className='sf-career-explore-title-font'>我还为您推荐了其它探索</div>
                                            : <div className='sf-career-explore-title-now'>推荐模块</div>
                                        }
                                    </div>

                                    <div className='sf-welcome-history-more'> 查看更多&gt;&gt;</div>
                                </div>

                                <div className='sf-career-explore-recommend-content'>
                                    <WaterfallCard  data={recommendData}  notify={this.recommendNotify}></WaterfallCard>
                                </div>
                            </div>
                        </div>

                        <div className='sf-career-explore-video'>
                            <div className='sf-career-explore-video-title'>
                                <img src={require('./../../img/' + sourcePath + '/career/video-icon.png')} alt=""></img>
                                <span>职业微视</span>
                            </div>

                            <div className='sf-career-explore-video-body'>
                                <CareerVideo data={videoData} total={videoTotal} notify={ this.videoNotify} > </CareerVideo>
                            </div>
                        </div>
                        
                    </div>
                   
                </div>
                
            </div>
        )
    }
}
export default CareerExplore;